import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/fantasy-flight-games': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M256 32.9l223.1 223.1-223.1 223.1-223.1-223.1zM88.3 255.8c11.3 11.2 29.8 29.5 41.1 40.7 20.2-19.9 40.5-39.9 61.9-61 12.1 12.6 24.5 25.6 36.5 38.1 12-11.7 23.7-23.1 35.7-34.7-7-7.5-32.1-32.8-35.1-35.8-1.9-1.9-2.3-3.2-0.1-5.4 15.6-15.2 39.2-17.8 57-5.1 8 5.7 14.3 11.6 48.5 44 10.8-11.2 22.2-22.9 33.5-34.7 0.5-0.5 0.1-2.6-0.6-3.4-0.1-0.1-37.5-40.6-62.2-59-33.6-25.1-78.3-23.1-119.8 18.7-84.6 85.2-94.5 95.5-96.5 97.5zM323.2 357.4c18.8-18.8 80.3-80.6 100.5-101.5-13.7-13.4-27.2-26.6-40.9-40-20 19.7-40.2 39.7-61.3 60.4-12.3-12.8-24.9-25.9-37.3-38.8-1.3 0.7-1.6 0.8-1.9 1.1-10.7 10.8-21.4 21.6-32.2 32.3-2.2 2.2-0.5 3.4 0.8 4.7 10.6 10.7 21.2 21.5 31.8 32.2 3.5 3.6 3.5 3.9-0.1 7.2-16.8 15.5-40.8 16.5-59.3 1.8-7.6-6.1-11.7-10.2-44.7-42.1-11.6 11.9-23.3 23.9-35.4 36.3 33.5 34.8 50.8 53.3 72.9 66.8 28.9 17.7 71.5 15 107-20.5zM256 0l256 256-256 256-256-256zM16 256l240 240 240-240-240-240z'
      }
    ]
  }
})
